import { ChangeDetectionStrategy, Component } from '@angular/core';
import { intersection } from 'lodash';
import { ToolName } from '../../../../cross-team-shared/tools-names';
import { makeTooltipProvider } from '../../../../cross-team-shared/tooltips/tooltip-utils';
import { AbstractMainToolbar2DComponent } from '../../../shared/toolbars/abstract-main-toolbar/abstract-main-toolbar-2d.component';

@Component({
  selector: 'h3-main-raster-coding-toolbar',
  templateUrl:
    '../../../shared/toolbars/abstract-main-toolbar/abstract-main-toolbar-2d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [makeTooltipProvider({ position: 'right' })],
  standalone: false,
})
export class MainRasterCodingToolbarComponent extends AbstractMainToolbar2DComponent {
  protected override getOrderedToolNames(): ToolName[] {
    const allowedTools = this.toolsHelperService.getAllowedTools(
      this.store.state().output.name,
    );

    return this.store.state().readOnly
      ? intersection(['Measure', 'Zoom'], allowedTools)
      : intersection(
          ['Paintbrush', 'Fill', 'Superpixel', 'Measure', 'Zoom'],
          allowedTools,
        );
  }
}
